import PropTypes from 'prop-types';

export const ThemeTemplateStyleRulePropTypes = PropTypes.shape({
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
});

export const ThemeTemplatePropTypes = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  recipes: PropTypes.arrayOf(PropTypes.string),
  description: PropTypes.string,
  type: PropTypes.string,
  tags: PropTypes.arrayOf(PropTypes.string),
  styleRules: PropTypes.arrayOf(ThemeTemplateStyleRulePropTypes).isRequired,
});

export const ThemeTemplatesPropTypes = PropTypes.arrayOf(ThemeTemplatePropTypes);
